import { Container, Sprite, Text, TextStyle, Graphics } from 'pixi.js'
import { FT } from 'ft'
import Underline from '#/components/Underline'
import Spinner from '#/components/Spinner'
import urls from '#/urls'
import store from '#/store'
import hooks from '#/hooks'
import Record from './Record'

const { rm } = FT

const $bg = 'prizes-bg'
const $bgShow = 'prizes-bg-show'
const $prizes = 'prizes'
const $buttonDraw = 'prizes-button-draw'
const $prize1 = 'prize-1'
const $prize2 = 'prize-2'
const $prize3 = 'prize-3'
const $prize4 = 'prize-4'
const $prize5 = 'prize-5'
const $prize6 = 'prize-6'
const $prize7 = 'prize-7'
const $explore = 'prizes-explore'
const $noticePhysicalGood = 'instruction-physical-good'
const $noticeVirtualGood = 'instruction-virtual-good'
const $more = 'prize-more'

rm.addImage($bg)
rm.addImage($bgShow)
rm.addImage($prizes)
rm.addImage($buttonDraw)
rm.addImage($prize1)
rm.addImage($prize2)
rm.addImage($prize3)
rm.addImage($prize4)
rm.addImage($prize5)
rm.addImage($prize6)
rm.addImage($prize7)
rm.addImage($explore)
rm.addImage($noticePhysicalGood)
rm.addImage($noticeVirtualGood)
rm.addImage($more)

const prizeNames = {
  1: '999 Q币',
  2: '10 Q币',
  3: '2 Q币',
  4: '冬境乐园门票',
  5: '冰雪节小熊',
  6: '冰雪节永久皮肤',
  7: '随机期限皮肤',
}

const nameStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 48,
  fill: '#ff5b40',
  stroke: '#ffffff',
  strokeThickness: 5,
})

const nameStyle1 = new TextStyle({
  fontFamily: 'sans-serif',
  fontSize: 30,
  fill: '#ff5b40',
  stroke: '#ffffff',
  strokeThickness: 5,
})

const closeStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 42,
  fill: '#99462c',
})

class Draw extends Container {
  constructor() {
    super()

    hooks.showPrize = this.showPrize

    const bg = new Sprite(rm.texture($bg))
    bg.interactive = true
    bg.on('pointerup', event => event.stopPropagation())
    bg.anchor.set(0.5)
    this.addChild(bg)

    const prizes = new Sprite(rm.texture($prizes))
    prizes.anchor.set(0.5)
    bg.addChild(prizes)

    const buttonDraw = new Sprite(rm.texture($buttonDraw))
    buttonDraw.anchor.set(0.5)
    prizes.addChild(buttonDraw)
    buttonDraw.interactive = true
    buttonDraw.on('pointerup', () => {
      this.addSpinner()
      hooks.draw()
    })
  }

  addSpinner() {
    const spinner = new Spinner()
    this.spinner = spinner
    spinner.interactive = true
    spinner.on('pointerup', event => {
      event.stopPropagation()
    })
    this.addChild(spinner)
  }

  removeSpinner() {
    if (!this.spinner) return
    this.spinner.parent.removeChild(this.spinner)
  }

  showPrize = () => {
    this.removeSpinner()
    const bgShow = new Sprite(rm.texture($bgShow))
    bgShow.anchor.set(0.5)
    this.addChild(bgShow)

    const close = new Text('X', closeStyle)
    close.anchor.set(0.5)
    close.x = 295
    close.y = -370
    close.interactive = true
    close.on('pointerup', () => {
      this.parent.removeChild(this)
    })
    bgShow.addChild(close)

    const { prize } = store
    let $prize
    let $name
    if (typeof prize === 'number' && prize <= 7) {
      $prize = new Sprite(rm.texture(`prize-${prize}`))
      $prize.anchor.set(0.5)
      $prize.y = -140
      bgShow.addChild($prize)

      $name = new Text(prizeNames[prize], nameStyle)
    } else {
      const y = -160
      const { url, name } = prize
      $prize = Sprite.from(url)
      $prize.anchor.set(0.5)
      $prize.scale.set(0.25, 0.25)
      $prize.y = y
      bgShow.addChild($prize)

      $prize.texture.baseTexture.on('loaded', () => {
        const border = new Graphics()
        border.lineStyle(2, 0xffffff, 1)
        border.drawRoundedRect(0, 0, $prize.width - 2, $prize.height - 2, 10)
        border.pivot.set(border.width / 2, border.height / 2)
        border.y = y
        bgShow.addChild(border)

        const mask = new Graphics()
        mask.beginFill(0x000000, 1)
        mask.drawRoundedRect(0, 0, $prize.width - 2, $prize.height - 2, 10)
        mask.endFill()
        mask.pivot.set(border.width / 2, border.height / 2)
        mask.y = y
        bgShow.addChild(mask)
        $prize.mask = mask
      })

      $name = new Text(name, nameStyle1)
    }

    $name.anchor.set(0.5)
    $name.y = -70
    bgShow.addChild($name)

    let $notice
    if (prize === 5) {
      $notice = new Sprite(rm.texture($noticePhysicalGood))
    } else {
      $notice = new Sprite(rm.texture($noticeVirtualGood))
    }
    $notice.anchor.set(0.5)
    $notice.y = -20
    bgShow.addChild($notice)

    const more = new Sprite(rm.texture($more))
    more.anchor.set(0.5)
    more.y = 65
    bgShow.addChild(more)

    const explore = new Sprite(rm.texture($explore))
    explore.anchor.set(0.5)
    explore.y = 200
    explore.interactive = true
    explore.on('pointerup', () => {
      window.location = urls.newSkin
    })
    bgShow.addChild(explore)

    const buttonRecord = new Underline('查看助力记录')
    buttonRecord.y = 300
    bgShow.addChild(buttonRecord)
    buttonRecord.interactive = true
    buttonRecord.on('pointerup', () => {
      const record = new Record(store.friends, () => {
        record.parent.removeChild(record)
      })
      record.pivot.set(record.width / 2, record.height / 2)

      this.addChild(record)
    })
  }
}

export default Draw
